<script>
  import Tweet from '../Tweet.svelte';

  export let tweets;
  export let lang = undefined;
  export let admin;

  let page = 0;

  let tweetsInternal = [];

  $: tweetsInternal = [tweets[page * 2], tweets[page * 2 + 1] || undefined].filter(tweet => tweet);
</script>

{#if tweets.length > 0}
  <div class='tweets-box'>
    {#if page > 0}
      <div class='tweets-box-action tweets-box-action-left' on:click={() => { page--; }}>
        <span class='material-icons'> chevron_left </span>
      </div>

      <div class='tweets-box-action tweets-box-action-up' on:click={() => { page--; }}>
        <span class='material-icons'> expand_less </span>
      </div>
    {/if}

    <div class='tweets-box-content'>
      {#each tweetsInternal as tweet}
        <Tweet value={tweet} bind:lang bind:admin/>
      {/each}
    </div>

    {#if page * 2 + 1 < tweets.length - 1}
      <div class='tweets-box-action tweets-box-action-right' on:click={() => { page++; }}>
        <span class='material-icons'> chevron_right </span>
      </div>

      <div class='tweets-box-action tweets-box-action-down' on:click={() => { page++; }}>
        <span class='material-icons'> expand_more </span>
      </div>
    {/if}
  </div>
{/if}

<style>
  .tweets-box {
    display: flex;
  }

  .tweets-box-action {
    justify-content: center;
    align-items: center;

    background: var(--grey-1);
    color: var(--grey-5);

    cursor: pointer;
    user-select: none;

    opacity: 0.5;

    transition: opacity 0.25s ease-in-out;
  }

  .tweets-box-action:hover {
    opacity: 1;
  }

  .tweets-box-action-left {
    display: flex;

    width: 20px;

    padding-right: 5px;

    margin-right: -5px;

    border-radius: 5px 0px 0px 5px;
  }

  .tweets-box-action-up {
    display: none;

    width: 100%;

    padding-bottom: 5px;

    margin-bottom: -5px;

    border-radius: 5px 5px 0px 0px;
  }

  .tweets-box-content {
    display: flex;
    flex-grow: 1;
    gap: 20px;
  }

  .tweets-box-action-right {
    display: flex;

    width: 20px;

    padding-left: 5px;

    margin-left: -5px;

    border-radius: 0px 5px 5px 0px;
  }

  .tweets-box-action-down {
    display: none;

    height: 20px;

    padding-top: 5px;

    margin-top: -5px;

    border-radius: 0px 0px 5px 5px;
  }

  :global(body.dark) .tweets-box-action {
    background: var(--grey-8);
    color: var(--grey-6);
  }

  @media only screen and (max-width: 850px) {
    .tweets-box {
      flex-direction: column;
    }

    .tweets-box-action-left {
      display: none;
    }

    .tweets-box-action-up {
      display: flex;
    }

    .tweets-box-content {
      flex-direction: column;
    }

    .tweets-box-action-right {
      display: none;
    }

    .tweets-box-action-down {
      display: flex;
    }
  }
</style>
